import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ElementRef,
  ViewChild
} from '@angular/core';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { Files } from '../../../models/agents/files';
import { environment } from '../../../../environments/environment';
import { GuidHelper } from '../../../helpers/guid-helper';
import * as moment from 'moment-timezone';
import swal from 'sweetalert2';
import { DateService } from '../../../services/date.service';
import { Store } from '@ngxs/store';
import { AuthState } from '../../../state-manager/state/auth.state';
import { map } from 'rxjs/operators';

const fileTypesCanBeImport = [
  '.jpeg',
  '.png',
  '.jpg',
  '.eml',
  '.csv',
  '.csv',
  '.csv',
  '.dbf',
  '.dif',
  '.xla',
  '.xlam',
  '.xls',
  '.xlsb',
  '.xlsm',
  '.xlsx',
  '.xlt',
  '.xltm',
  '.xltx',
  '.xlw',
  '.xml',
  '.xps',
  '.doc',
  '.docm',
  '.docx',
  '.docx',
  '.dot',
  '.dotm',
  '.dotx',
  '.rtf',
  '.wps',
  '.pdf'
];

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit {
  @Input() personas: Array<String> = [];
  @Input() investorFileType = '';
  @Input() date = moment().utc().format();
  @Input() tipo: 'PF' | 'PJ';
  @Input() filePosition: 'up' | 'down' = 'down';
  @Input() fileStyle: 'normal' | 'simple' = 'normal';
  @Input() defaultFiles: Array<Files> = null;
  investorFileTypeRequired = false;
  @Input('investorFileTypeRequired') set setInvestorFileTypeRequired(attribute: boolean | '') {
    this.investorFileTypeRequired = attribute === '' || attribute;
  }
  dateRequired = false;
  @Input('dateRequired') set setDateRequired(attribute: boolean | '') {
    this.dateRequired = attribute === '' || attribute;
  }
  @Input() blockDates = true;
  @Output() completeItem = new EventEmitter<{
    item: any;
    response: any;
    status: any;
    headers: any;
  }>();
  @Output() completeRemoveItem = new EventEmitter<File>();

  files: Array<Files> = new Array<Files>();
  uriUpload =
    environment.apiCadastroSettings.url +
    environment.apiCadastroSettings.saveInvestorDocumentUpload;
  uploader: FileUploader;
  controlID: string = GuidHelper.generate();
  token: string;
  hash: string;

  hasBaseDropZoneOver = false;
  hasAnotherDropZoneOver = false;
  fileLoading = false;

  @ViewChild('InputFile') inputFile: ElementRef;

  constructor(protected dateService: DateService, protected store: Store) {
    this.store
      .select(AuthState.CRYPTO)
      .pipe(
        map((token) => this.token = token ? token : this.token)
      )
      .subscribe();

    this.store
      .select(AuthState.HASH)
      .pipe(
        map((hash) => this.hash = hash ? hash : this.hash)
      )
      .subscribe();
  }

  ngOnInit() {}

  setFiles(files: Array<Files>, clear = false) {
    if (clear) {
      this.files = [];
    }
    const arrayFiles = [];

    files.map(file => {
      arrayFiles.push(new Files(file));
    });

    this.files = this.files.concat(arrayFiles);
  }

  hasFiles() {
    if (this.files && this.files.length > 0) {
      return this.files.filter((fl) => fl.isDeleted === false).length > 0;
    }

    return false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.handleInitFileUploader(changes);

    if (this.defaultFiles) {
      this.files = [...this.defaultFiles];
    }

    this.uploader.onAfterAddingFile = (item: FileItem) => {
      if (!fileTypesCanBeImport.find((type) => item._file.name.includes(type))) {
        this.completeItem.emit({
          item: {},
          response: { wrongType: 'wrong type' },
          status: 'wrong type',
          headers: {}
        });

        this.uploader.removeFromQueue(
          this.uploader.queue[this.uploader.queue.length - 1]
        );

        swal({
          title: 'Erro no upload!',
          text: 'Você inseriu um tipo de arquivo inválido.',
          type: 'warning'
        }).catch(swal.noop);
      }
    };

    this.uploader.onBeforeUploadItem = (item: FileItem) => {
      this.fileLoading = true;
    };

    this.uploader.onCompleteItem = (item, response, status, headers) => {
      let responseChanged = response;
      this.fileLoading = false;

      if (item.isSuccess) {
        const json = JSON.parse(responseChanged);
        json.documentDate = this.date
          ? moment(this.date).utc().format()
          : moment().utc().format();

        const file: Files = {
          fileName: json.documentName,
          fileType: json.documentType,
          isDeleted: json.documentIsDeleted,
          documentDate: json.documentDate
        };

        this.files.push(new Files(file));

        responseChanged = JSON.stringify(json);
      }

      this.inputFile.nativeElement.value = '';

      this.completeItem.emit({
        item: item,
        response: responseChanged,
        status: status,
        headers: headers
      });
    };
  }

  handleInitFileUploader(changes: SimpleChanges) {
    if (
      changes.investorFileType &&
      changes.investorFileType.currentValue !==
      changes.investorFileType.previousValue
    ) {
      const headers = [{ name: 'Authorization', value: `Basic ${this.token}` }];

      if (this.hash) {
        headers.push({ name: 'AuthorizationHash', value: this.hash });
      }

      this.uploader = new FileUploader({
        url: this.uriUpload,
        isHTML5: true,
        method: 'POST',
        autoUpload: true,
        headers,
        additionalParameter: {
          document_type: this.investorFileType
        }
      });
    }
  }

  onFileSelected() {
    if (
      this.blockDates &&
      (!this.dateService.isValid(this.date) || this.dateService.isFuture(this.date))
    ) {
      this.completeItem.emit({
        item: {},
        response: { invalid: 'invalid date' },
        status: 'invalid date',
        headers: {}
      });

      this.uploader.removeFromQueue(
        this.uploader.queue[this.uploader.queue.length - 1]
      );

      return;
    }

    if (
      (this.investorFileTypeRequired && !this.investorFileType) ||
      (this.dateRequired && !this.date)
    ) {
      const missing = [];

      if (!this.date) {
        missing.push('date');
      }
      if (!this.investorFileType) {
        missing.push('documentType');
      }

      this.completeItem.emit({
        item: {},
        response: { missing },
        status: missing,
        headers: {}
      });

      this.uploader.removeFromQueue(
        this.uploader.queue[this.uploader.queue.length - 1]
      );

      return;
    }
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  removeFile(file) {
    this.completeRemoveItem.emit(file);
  }

  filterFiles(files: Files[] = [], type: string) {
    return files.filter(
      (value) =>
        value.fileType.toLowerCase() === type.toLowerCase() &&
        value.isDeleted === false
    );
  }
}
